<script setup lang="ts">
defineOptions({ inheritAttrs: false })
defineProps<{ empty: boolean; txt?: stringI18n }>()
const t2 = useT2({})
</script>

<template>
  <UiGrow :open="empty">
    <div class="m_pr04 m_pl04 _w70ch _mb2">
      <div v-bind="$attrs" class="_italic _br14 _b5 _w100p _glass bg _ctr _noselect _hidden _h120 _c45 _fw-l _fs44">
        <span v-for="_ in 4" class="_wmax" :class="$style.s">{{ txt || t2('Empty') }}</span>
      </div>
    </div>
  </UiGrow>
</template>

<style module>
.s {
  transform: rotate(11deg);
}
</style>
